import PropTypes from 'prop-types';

const ServiceItem = (props) => {
  const cdnURL = window.beaches_app.global.cdn_url;

  const {
    image,
    title,
    subTitle,
    description,
    list,
    price,
    footer
  } = props;

  return (
    <div className="item">
      <div className="item-panel">
        <figure>
          <img src={`${cdnURL}${image}`} alt={title} className="img-responsive"/>
          <figcaption>
            {title}
            {subTitle && <span className="show">{subTitle}</span>}
          </figcaption>
        </figure>
        {description && <p>{description}</p>}
        {list && <ul className="item-list">
          {list.map((item, index) => <li key={index}>{item}</li>)}
        </ul>}
        <div className="price">
          <span className="num">${price}</span>
          <span><small>PP</small>(USD)</span>
        </div>
        <div className="additional">
          <span>To book, </span> 
          {footer != '' ? footer : 'please call your Pre-Travel Wedding Planner or your Travel Agent'}
        </div>
      </div>
    </div>
  );
};

ServiceItem.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  list: PropTypes.array,
  price: PropTypes.number,
  footer: PropTypes.string
};

ServiceItem.defaultProps = {
  image: '',
  title: '',
  subTitle: '',
  description: '',
  price: 0,
  footer: ''
};

export default ServiceItem;
